import { ClientSchema } from "@common/schemas/client.schema";
import { ClientDetailsRow } from "../views/clientViewConfig";

export function transformWorkspaceToClientRow(
    client: ClientSchema,
): ClientDetailsRow {
    // Deduplicate invites by id
    const allInvites = client.entities.flatMap(
        (entity) => entity.invites ?? [],
    );
    const invitesMap = new Map(allInvites.map((invite) => [invite.id, invite]));
    const invites = Array.from(invitesMap.values());

    // Deduplicate members by userId
    const allMembers = client.entities.flatMap(
        (entity) => entity.members ?? [],
    );
    const membersMap = new Map(
        allMembers.map((member) => [member.userId, member]),
    );
    const members = Array.from(membersMap.values());

    return {
        ...client,
        closeStatus: undefined,
        closeDate: undefined,
        priority: undefined,
        dueDate: null,
        legalType: null,
        closeStage: undefined,
        closeStageUpdatedAt: undefined,
        invites,
        members,
        type: "workspace",
        entities: client.entities.map((entity) => ({
            ...entity,
            type: "entity" as const,
        })),
    };
}
